import { getAuthenticatedSupabaseClient } from '@/integrations/supabase/client';
import { logger } from '@/lib/logger';

// Fetch all floor plans that belong to a given workspace (basic fields only)
export const getWorkspaceFloorPlans = async (workspaceId: string) => {
  if (!workspaceId) return { data: [], error: null };

  try {
    const supabase = await getAuthenticatedSupabaseClient();
    // Floor plans are linked to workspaces through projects
    const { data, error } = await (supabase as any)
      .from('floor_plans')
      .select('id,name,project_id,projects!inner(name,workspace_id),floor_plan_permissions(permission_level)')
      .eq('projects.workspace_id', workspaceId)
      .eq('floor_plan_permissions.workspace_id', workspaceId)
      .order('created_at', { ascending: false });

    return { data: data || [], error };
  } catch (err) {
    logger.error('Error fetching workspace floor plans:', err);
    return { data: [], error: err as any };
  }
}; 
